import type { Order } from '@scayle/storefront-nuxt'

export type AppliedFees = Order['cost']['appliedFees']

export const getShippingCost = (
  appliedFees: AppliedFees = [],
  options: { includeTax: boolean } = { includeTax: false },
): number => {
  if (!appliedFees?.length) {
    return 0
  }

  return appliedFees
    .filter((fee) => fee.category === 'delivery')
    .reduce((total, fee) => {
      return (
        total +
        (options.includeTax ? fee.amount.withTax : fee.amount.withoutTax)
      )
    }, 0)
}

export const divideByHundred = (price: number): number => price / 100

export const formatPriceWithDecimals = (price: number): number =>
  Number((price / 100).toFixed(2))

export const calculateDiscountPercentage = (
  saleDiscount: number,
  originalPrice: number,
): number => {
  if (originalPrice === 0 || saleDiscount === 0) {
    return 0
  }
  return Number(((saleDiscount / originalPrice) * 100).toFixed(2))
}
